export default {

    /**
     * Determine if scrollParent is scrolled such that element is in view.
     * @param scrollParent Parent item
     * @param element Target
     * @returns {boolean} True if element is visible
     */
    isScrolledIntoView: function(scrollParent, element) {
        var el = $(element);
        var elTop = el.offset().top;
        var elBottom = el.height() + elTop;

        var scroll = $(scrollParent);
        var scrollTop = scroll.scrollTop();
        var scrollBottom = scroll.height() + scrollTop;

        return elBottom <= scrollBottom && elTop >= scrollTop;
    },

    /**
     * Scroll element into view.
     *
     * @param el jQuery element
     */
    scrollIntoView: function(el) {
        var node = el[0];
        if (node.scrollIntoViewIfNeeded) {
            // use Chrome's extended function when present
            node.scrollIntoViewIfNeeded();
        } else {
            node.scrollIntoView();
        }
    },

    /**
     * Scroll to top of element.
     *
     * @param el jQuery element
     */
    scrollToTop: function(el) {
        el[0].scrollTop = 0;
    },

    /**
     * Convert a point on a page to a point inside a given element.
     * @param container Element at (0,0) of result.
     * @param x X position on page
     * @param y Y position on page
     * @returns {{x: number, y: number}}
     */
    calculateRelativePoint: function(container, {x, y}) {
        const $container = $(container);
        const rect = $container[0].getBoundingClientRect();
        return {
            x: x + $container.scrollLeft() - rect.left,
            y: y + $container.scrollTop() - rect.top
        }
    }

};
